import _ from 'underscore';

export default function knockManager() {
  const { knock, meeting } = this.store.getState();

  if (knock && (!this._knock || !_.isMatch(this._knock, knock))) {
    //TODO: change polymer to expose internal socket object OR the socketId.
    const socketId = this.socket._socket.id;

    this._knock = {
      ...knock,
      socketId,
      attendeeId: meeting?.attendeeResponse?.Attendee?.AttendeeId
    };
    this.socket.emit('knock', this._knock);
  }

  if (knock && knock.rejected) {
    this._knock = null;
  }
}
